import store from '@/store'

export default {
  computed: {
    accountDetails () {
      return store.getters['getAccountDetails']
    },
    accountNumber () {
      return this.creditAccountDetails && this.creditAccountDetails.AccountNumber
    },
    personalDetails () {
      return store.getters['getPersonalDetails']
    },
    creditAccountDetails () {
      return this.accountDetails && this.accountDetails.find(item => item.IDMMAccountClass === 'CREDIT')
    },
    walletBalances () {
      return store.getters['getWalletBalance']
    },
    siteCreditBalance () {
      return this.walletBalances && this.walletBalances.balances && this.walletBalances.balances.find(balance => balance.type === 'RM')
    },
    totalCacheBalance () {
      return this.walletBalances && this.walletBalances.balances && this.walletBalances.balances.find(balance => balance.type === 'RM')
    },
    totalBalanceValue () {
      var balance = 0
      if (this.siteCreditBalance && this.siteCreditBalance.balance && !isNaN(this.siteCreditBalance.amount)) {
        balance += this.siteCreditBalance.amount
      }
      if (this.totalCacheBalance && this.totalCacheBalance.balance && !isNaN(this.totalCacheBalance.amount)) {
        balance += this.totalCacheBalance.amount
      }
      return balance
    }
  },

  methods: {

  },

  created () {

  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Account.js